import Axios from 'axios';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FORGOT_PASSWORD_EMAIL_API } from '../../config/rest_endpoints';
import { AUTH_ROUTES } from '../../routers/RouteConstants';
import Logo from '../../components/common/Logo';
import './style.css';

const ResetPassword = () => {
  const [email, setEmail] = useState('');
  const [token] = useState(localStorage.getItem('token'));
  const [isLoad, setIsLoad] = useState(false);
  const [respMessage, setRespMessage] = useState('');
  const [isError, setIsError] = useState(null);

  const handleEmail = e => {
    setEmail(e.target.value);
  };

  const clearState = () => {
    setEmail('');
  };

  const submitMail = () => {
    const authToken = JSON.parse(token);
    const payload = {
      email: email,
    };
    setIsLoad(true);
    const headers = { Authorization: 'Bearer ' + authToken };
    Axios.post(FORGOT_PASSWORD_EMAIL_API, payload, { headers })
      .then(res => {
        if (res) {
          let { response } = res.data;
          setRespMessage(response.msg);
          setIsError(false);
          setIsLoad(false);
          setTimeout(() => {
            clearState();
          }, 1000);
        }
      })
      .catch(err => {
        console.log(`err`, err);
        setRespMessage('Please correct your email address and try again.  If your email address is correct,  please contact your company’s Helium Administrator to request access');
        setIsLoad(false);
        setIsError(true);
      });
  };

  return (
    <section className="login-form-container">
      <article className="login-page">
        <picture className="site-logo">
          <Logo width={'450px'} height={'450px'} />
        </picture>
        <div className="login-form" action="index.html" style={{ background: '#f1f1f1' }}>
          <div className="card mb-0 border-0 shadow-0">
            <div className="card-body center-class">
              <div className="text-center mb-3">
                <h5 className="mb-0">Password recovery</h5>
                <span className="d-block text-muted">We'll send you instructions in email</span>
              </div>
              {isError === null ? (
                ''
              ) : isError ? (
                <div className="alert alert-info alert-styled-right alert-dismissible">
                  <button type="button" className="close" data-dismiss="alert">
                    <span>×</span>
                  </button>
                  <span className="font-weight-semibold">{respMessage}</span>
                </div>
              ) : (
                <div className="alert alert-success alert-styled-right alert-dismissible">
                  <button type="button" className="close" data-dismiss="alert">
                    <span>×</span>
                  </button>
                  <span className="font-weight-semibold">{respMessage}</span>
                </div>
              )}
              <div className="form-group form-group-feedback form-group-feedback-right">
                <input
                  type="email"
                  className="form-control"
                  value={email}
                  onChange={handleEmail}
                  placeholder="Your email"
                />
                <div className="form-control-feedback">
                  <i className="icon-mail5 text-muted"></i>
                </div>
              </div>
              <button
                type="submit"
                className="btn btn-theme-primary  btn-block"
                onClick={submitMail}
                disabled={isLoad ? true : false}
              >
                Reset password
                <i
                  className={isLoad ? 'icon-spinner2 spinner ml-2' : 'icon-paperplane ml-2'}
                ></i>{' '}
              </button>
              <div className="form-group text-right mt-2">
                <Link to={AUTH_ROUTES.login}>Back to Sign In</Link>
              </div>
            </div>
          </div>
        </div>
      </article>
    </section>
  );
};

export default ResetPassword;
